import React, {useMemo} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
    getInitialMapCenterByPointsSingleVoyage
} from '@containers/singleVoyage/containers/points/helpers/getInitialMapCenterByPoints';
import MapMutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/map/MapMutateSingleVoyage";

const MapWithInitialCenterMutateSingleVoyage = () => {

    const {points} = useRootContextMutateSingleVoyage()

    const initialCenter = useMemo(() => {
        return getInitialMapCenterByPointsSingleVoyage(points)
    }, [])

    return (
        <MapMutateSingleVoyage
            initialCenter={initialCenter}
        />
    );
};

export default MapWithInitialCenterMutateSingleVoyage;